import { useMemo, useState } from "react";

import useEvent from "./useEvent";

const useMore = <T>(data: T[], options: { pageSize: number }) => {
  const [pageIndex, setPageIndex] = useState(1);

  const pageTotal = useMemo(
    () => Math.floor(data.length / options.pageSize),
    [data, options.pageSize]
  );

  const handleNext = useEvent(() => {
    if (pageIndex >= pageTotal) {
      return;
    }

    setPageIndex(pageIndex + 1);
  });

  const handlePrev = useEvent(() => {
    if (pageIndex <= 1) {
      return;
    }
    setPageIndex(pageIndex - 1);
  });

  return useMemo(
    () => ({
      pageIndex,
      historyData: data.slice(0, pageIndex * options.pageSize),
      hasMore: pageIndex < pageTotal,
      itemLeft: pageTotal - pageIndex,
      currentPageData: data.slice((pageIndex - 1) * options.pageSize, pageIndex * options.pageSize),
      handleNext,
      handlePrev,
    }),
    [pageIndex, data, options.pageSize, pageTotal, handleNext, handlePrev]
  );
};

export default useMore;
